import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tnq-divider',
  template: '<hr class="border" />',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './divider.component.scss',
})
export class DividerComponent {}
